// src/data/offersTravel.js

const baseImagePath = process.env.REACT_APP_BASE_IMAGE_PATH;

const offers = [
  {
    id: "a1",
    category: "",
    country: "Österreich",
    title: "Lawinentag",
    subtitle: "Schnee- und Lawinenkunde vom Fachmann.",
    text_overview:
      "Wir leben Schnee und beschäftigen uns vom ersten bis zum letzten Tag der Saison damit, nicht nur als Bergführer, sondern auch aus lawinenkundlichem Interesse aus anderen Betätigungsfeldern. Die Lawinentage sind eine gute Möglichkeit für interessierte Schneemenschen sich auf dem Weg zu mehr Eigenverantwortung ohne Bindung und Terminstress begleiten zu lassen.",
    text_itinerary:
      "Wir treffen uns irgendwo im Schigebiet. Je nach Wissensstand starten wir mit den Basics der Verschüttetensuche und durchleuchten die amtlichen Lawinenprognosen aus Salzburg und Tirol. Es ist sehr spannend die Entstehung eines Lageberichts nachzuvollziehen und das führt uns unmittelbar zu fortgeschritteneren Themen wie Tourenplanung, Taktik und Spurwahl. Wissensdurstigen wird der Blick in die Schneedecke durch Schneeprofile geschärft und werdende ExpertInnen bekommen einen Einblick in moderne computerunterstütze Methoden der Lawinenprognose. Dies alles geschieht anhand eines kleinen Erkundungstrips der Gegend und den verschiedenen Arten des Schnees.",
    price: "ab € 450,00",
    prices: {
      1: "450,00",
      2: "550,00",
      3: "650,00",
      4: "750,00",
      5: "850,00",
    },
    inclServices: [
      "Lawinenkundliche Ausbildung und Führung durch staatlich geprüften Berg- und Schiführer",
    ],
    exclServices: ["Liftkarten falls benötigt"],
    equipment: "",
    date: "Nach Absprache jederzeit im Winter.",
    duration: "1 Tag",
    place: "Saalbach-Hinterglemm, Salzburg",
    maxGuests: "5",
    overalleLevel: 1,
    levelTech: 22,
    levelTechText: "Ein wenig Erfahrung im winterlichen Gelände",
    levelFitness: 11, 
    levelFitnessText: "Genussreicher Tag im Freien",
    link: "/avalanches",
    isNew: true,

    imgHead: `${baseImagePath}snow/offers/a1_Lawinentage/head.jpg`,
    imgOne: `${baseImagePath}snow/offers/a1_Lawinentage/IMG_2239.jpg`,
    imgTwo: `${baseImagePath}snow/offers/a1_Lawinentage/IMG_1570.jpg`,
    imgThree: `${baseImagePath}snow/offers/a1_Lawinentage/IMG_1553.jpg`,
  },

  {
    id: "a2",
    category: "",
    country: "Österreich",
    title: "Snow Safety Camp 2024",
    subtitle: "für Anfänger:innen und Wiedereinsteiger:innen",
    text_overview:
      "Bist du bereit, in nur 3 Tagen die Grundlagen über Schnee und Lawinen zu erlernen oder deine Kenntnisse aufzufrischen? Starte sicher in die Schitouren- und Freeridesaison und sei dabei im SNOW SAFETY CAMP 2024 im Spielberghaus in Saalbach-Hinterglemm.",
    text_itinerary:
 "Tag 1: An unserem ersten Tag gibt es um 15 Uhr und für all jene die später Ankommen um ca. 18:30 bis 19:00 Uhr (genaue Uhrzeit wird noch fixiert) einen Personen- und Gepäcktransport zu unserer Unterkunft dem Almgasthof Spielberghaus in Saalbach. Gemeinsam starten wir mit einem Willkommensgetränk und lassen das Camp mit einem gemeinsamen Abendessen entspannt beginnen. Im Anschluss gibt es einen inhaltlichen Input zum Thema Schneeprofile und professionellen Lawinen-Dashboards. So starten wir bestens vorbereitet in unser Abenteuer! Tag 2: Nach einem stärkenden Frühstück geht’s los: Wir checken unsere Ausrüstung und legen den Grundstein für das Erlernen und Vertiefen von LVS-Basics. Der Tag bringt spannende Suchszenarien, Tourenplanungen und praktische Übungen, die uns auf die Herausforderungen am Berg vorbereiten. Am Abend wartet ein vertiefender Input zur Lawinenwarnung, bevor wir uns in die wohlverdiente Erholung begeben. Tag 3: ist für eine ausgedehnte Skitour reserviert, bei der wir das Gelernte direkt anwenden. Die verschneite Bergwelt begleitet uns auf unserer Tour, bei der Theorie und Praxis verschmelzen. Ein unvergesslicher Abschluss, bevor wir uns verabschieden – mit neuem Wissen und wertvollen Erfahrungen im Gepäck.",
    expectations: [
      "Ausbildung und Training durch staatlich geprüfte Berg- und Skiführer:innen ",
      "Vorträge von Lawinenexpert:innen",
      "Interpretation des Lawinenlageberichts",
      "Lawinen-Verschüttungsszenarien",
      "Gefahrenbeurteilung im Gelände Taktik, Spurwahl, Timing, ...",
      "Spaß und Freude beim Erforschen und Erfahren der komplexen Materie Schnee",
      "Chance auf Überraschungspreise ",
    ],
    price: "€ 512,00",
    prices: {
      1: "512,00",
      2: "1024,00",
      3: "1536,00",
    },
    inclServices: [
      "Ausbildung und Training durch staatlich geprüfte Berg- und Skiführer:innen ",
      "Vorträge von Lawinenexpert:innen",
      "2 Nächte inkl. Halbpension und Transfer Welcome Drink ",
      "Leihweise Notfallausrütung (Schaufel, Sonde, LVS-Gerät) ",
    ],
    exclServices: [
      "An- und Abreise",
      "Getränke",
      "Zusätzliche Verpflegung ",
      "Liftkarten je nach Wetter",
    ],
    equipment: [
      "Tourenschi, Stöcke, Felle",
      "Helm",
      "Schi- und Sonnenbrille",
      "Sonnencreme",
      "Wenn vorhanden LVS-Ausrüstung",
      "Wenn vorhanden Lawinen-Airbag",
      "Dicke und dünne Handschuhe, Wechselhandschuhe",
    ],
    date: "20.12.2024 - 22.12.2024",
    duration: "2,5 Tage",
    place: "Almgasthof Spielberghaus, Saalbach",
    maxGuests: "7",
    overalleLevel: 1,
    levelTech: 11,
    levelTechText: "",
    levelFitness:11,
    levelFitnessText: "",
    link: "/avalanches",
    isNew: true,

    imgHead: `${baseImagePath}snow/offers/a2_safety_days/head.jpg`,
    imgOne: `${baseImagePath}snow/offers/a2_safety_days/_MR30349.jpg`,
    imgTwo: `${baseImagePath}snow/offers/a2_safety_days/IMG_1734.jpg`,
    imgThree: `${baseImagePath}snow/offers/a2_safety_days/_MR30307.jpg`,
    descrImgOne: "",
    descrImgTwo: "",
    descrImgThree: "",
  },

  /*{
    id: "a3",
    category: "",
    title: "Snow Safety Camp 2025",
    subtitle: "für Fortgeschrittene",
    text_overview: "",
    text_itinerary: "",
    price: "ab € 000,00",
    prices: {
      1: "750,00",
      2: "900,00",
    },
    inclServices: [],
    exclServices: [],
    equipment: "",
    date: "",
    duration: "",
    place: "",
    maxGuests: "",
    overalleLevel: ,
    levelTech: ,
    levelTechText: "",
    levelFitness: ,
    levelFitnessText: "",
    link: "/avalanches",
    isNew: true,

    imgHead: `${baseImagePath}snow/offers/a2_safety_days/IMG_2334.jpg`,
    imgOne: "",
    imgTwo: "",
    imgThree: "",
    descrImgOne: "",
    descrImgTwo: "",
    descrImgThree: "",
  },*/
];

export default offers;

/*{ 
  {
    id: "a1",
    category: "",
    title: "",
    subtitle: "",
    text_overview: "", 
    text_itinerary: "",
    price: "ab € 000,00",
    prices: {
      1: 750, 
      2: 900  
    },
    inclServices: [], 
    exclServices: [],
    equipment: "",
    date: "",
    duration: "",
    place: "",
    maxGuests: "",
    overalleLevel: "",
    levelTech: "",
    levelFitness: "",
    link: "/avalanches",
    isNew: true,

    imgHead: `${baseImagePath}mountainguide/offers/m1_Traunspitzl_Neue_Zeiten/IMG_7534_head.jpg`,
    imgOne: '',
    imgTwo: '',
    imgThree: '',
  }
  }
  */
